import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FiFacebook, FiInstagram, FiYoutube, FiTwitter,
  FiPhone, FiMail, FiMapPin, FiArrowRight,
} from 'react-icons/fi';
import styles from './Footer.module.css';

const QUICK_LINKS = [
  { to: '/',                    label: 'Home' },
  { to: '/products',            label: 'All Products' },
  { to: '/products?featured=true', label: 'Featured Deals' },
  { to: '/cart',                label: 'Shopping Cart' },
  { to: '/orders',              label: 'Track Orders' },
  { to: '/profile',             label: 'My Account' },
];

const CATEGORIES = [
  { to: '/products?category=electronics',   label: '📱 Electronics' },
  { to: '/products?category=fashion',       label: '👗 Fashion' },
  { to: '/products?category=home',          label: '🏠 Home & Living' },
  { to: '/products?category=food',          label: '🛒 Food & Grocery' },
  { to: '/products?category=beauty',        label: '💄 Beauty & Health' },
  { to: '/products?category=sports',        label: '⚽ Sports' },
];

const POLICIES = [
  { to: '#', label: 'Return Policy' },
  { to: '#', label: 'Shipping Policy' },
  { to: '#', label: 'Privacy Policy' },
  { to: '#', label: 'Terms of Service' },
  { to: '#', label: 'FAQ' },
];

const PAYMENT_METHODS = [
  { name: 'bKash',      bg: '#E2136E', text: '#fff' },
  { name: 'Nagad',      bg: '#F6821F', text: '#fff' },
  { name: 'Rocket',     bg: '#8B5CF6', text: '#fff' },
  { name: 'VISA',       bg: '#1A1F71', text: '#fff' },
  { name: 'Mastercard', bg: '#EB001B', text: '#fff' },
  { name: 'COD',        bg: '#16A34A', text: '#fff' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) { setSubscribed(true); setEmail(''); }
  };

  return (
    <footer className={styles.footer} role="contentinfo">
      {/* ── Newsletter Banner ── */}
      <div className={styles.newsletterBand}>
        <div className={`container ${styles.nlInner}`}>
          <div className={styles.nlText}>
            <h3>🔔 Subscribe for Exclusive Deals</h3>
            <p>Get the best offers, new arrivals & flash sales straight to your inbox.</p>
          </div>
          {subscribed ? (
            <div className={styles.nlSuccess}>
              ✅ Thank you for subscribing! আপনার সাবস্ক্রিপশন সফল হয়েছে।
            </div>
          ) : (
            <form className={styles.nlForm} onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Enter your email address..."
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                className={styles.nlInput}
                aria-label="Email for newsletter"
              />
              <button type="submit" className={styles.nlBtn}>
                Subscribe <FiArrowRight size={15} />
              </button>
            </form>
          )}
        </div>
      </div>

      {/* ── Main Footer Grid ── */}
      <div className={styles.mainFooter}>
        <div className="container">
          <div className={styles.grid}>

            {/* Brand column */}
            <div className={styles.brandCol}>
              <Link to="/" className={styles.logo} aria-label="BDShop home">
                <span aria-hidden="true">🛒</span>
                <span>BD<strong>Shop</strong></span>
              </Link>
              <p className={styles.tagline}>
                বাংলাদেশের সেরা অনলাইন শপিং প্ল্যাটফর্ম।
                ঘরে বসে কেনাকাটা করুন, দ্রুত ডেলিভারি পান।
              </p>

              {/* Contact info */}
              <div className={styles.contactList}>
                <a href="tel:+88016xxxxxxxx" className={styles.contactItem}>
                  <div className={styles.contactIcon}><FiPhone size={14} /></div>
                  <span>+880-16xx-xxxxxx (Hotline)</span>
                </a>
                <a href="mailto:support@bdshop.com" className={styles.contactItem}>
                  <div className={styles.contactIcon}><FiMail size={14} /></div>
                  <span>support@bdshop.com</span>
                </a>
                <div className={styles.contactItem}>
                  <div className={styles.contactIcon}><FiMapPin size={14} /></div>
                  <span>Dhaka, Bangladesh</span>
                </div>
              </div>

              {/* Social */}
              <div className={styles.socialRow}>
                {[
                  { icon: FiFacebook,  label: 'Facebook',  href: '#' },
                  { icon: FiInstagram, label: 'Instagram', href: '#' },
                  { icon: FiYoutube,   label: 'YouTube',   href: '#' },
                  { icon: FiTwitter,   label: 'Twitter',   href: '#' },
                ].map(s => (
                  <a key={s.label} href={s.href} className={styles.socialBtn} aria-label={s.label} rel="noopener noreferrer">
                    <s.icon size={16} />
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className={styles.linkCol}>
              <h4 className={styles.colTitle}>Quick Links</h4>
              <ul className={styles.linkList}>
                {QUICK_LINKS.map(l => (
                  <li key={l.to}>
                    <Link to={l.to} className={styles.footLink}>
                      <FiArrowRight size={11} /> {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Categories */}
            <div className={styles.linkCol}>
              <h4 className={styles.colTitle}>Shop Categories</h4>
              <ul className={styles.linkList}>
                {CATEGORIES.map(c => (
                  <li key={c.to}>
                    <Link to={c.to} className={styles.footLink}>{c.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Policies + App */}
            <div className={styles.linkCol}>
              <h4 className={styles.colTitle}>Help & Policies</h4>
              <ul className={styles.linkList}>
                {POLICIES.map(p => (
                  <li key={p.label}>
                    <Link to={p.to} className={styles.footLink}>
                      <FiArrowRight size={11} /> {p.label}
                    </Link>
                  </li>
                ))}
              </ul>

              {/* Business hours */}
              <div className={styles.hours}>
                <p className={styles.hoursTitle}>📞 Support Hours</p>
                <p>Sat – Thu: 9 AM – 9 PM</p>
                <p>Friday: 2 PM – 9 PM</p>
              </div>
            </div>
          </div>

          {/* Payment methods */}
          <div className={styles.paymentRow}>
            <p className={styles.payLabel}>We Accept:</p>
            <div className={styles.payBadges}>
              {PAYMENT_METHODS.map(m => (
                <span
                  key={m.name}
                  className={styles.payBadge}
                  style={{ background: m.bg, color: m.text }}
                  title={m.name}
                >
                  {m.name}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className={styles.bottomBar}>
        <div className={`container ${styles.bottomInner}`}>
          <p>© {new Date().getFullYear()} BDShop. All rights reserved. Made with ❤️ in Bangladesh 🇧🇩</p>
          <div className={styles.bottomLinks}>
            <Link to="#">Privacy</Link>
            <span aria-hidden="true">·</span>
            <Link to="#">Terms</Link>
            <span aria-hidden="true">·</span>
            <Link to="#">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
